import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { CHAT_STORE_STATUS } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { hydrateConversationSpaces } from './hydrateConversationSpaces';
import { setConversationData } from './setConversationData';
import type { ChatStoreAction } from './types';

/** Load identity for conversations outside the ordinary chat list, such as Jira coding sessions. */
export const hydrateMissingConversationAgent =
	(conversationId: string): ChatStoreAction<Promise<void>> =>
	async ({ getState, dispatch }, { assistanceService, onConversationSpacesHydrated }) => {
		const conversation = getState().conversations[conversationId];
		const metadata = await assistanceService.fetchConversationMetadata(conversationId);
		const current = getState().conversations[conversationId];
		// Do not overwrite a newer selection or revive a conversation removed during the request.
		if (
			current?.status !== CHAT_STORE_STATUS.loadingChat ||
			current.agent !== conversation?.agent
		) {
			return;
		}
		if (isExperimentEnabled('rovo_chat_spaces_experiment')) {
			hydrateConversationSpaces({
				conversationId,
				metadata,
				dispatch,
				onConversationSpacesHydrated,
			});
		}
		if (metadata.agent?.agent_id) {
			dispatch(
				setConversationData({
					conversationId,
					data: {
						agent: metadata.agent,
						sourceAgentId: metadata.agent.agent_id,
					},
				}),
			);
		}
	};
